import { render, staticRenderFns } from "./ObjectCardDialog.vue?vue&type=template&id=6ac0b573&scoped=true&"
import script from "./ObjectCardDialog.vue?vue&type=script&lang=js&"
export * from "./ObjectCardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac0b573",
  null
  
)

export default component.exports
import {QDialog} from 'quasar'
component.options.components = Object.assign({QDialog}, component.options.components || {})
